<script setup lang="ts">
  import GlobalErrorPage from '@common/shared-ui-layer/components/GlobalErrorPage.vue'
  import CPGlobalErrorTopBar from './components/CPGlobalErrorTopBar.vue'

  import type { NuxtError } from 'nuxt/app'

  const props = defineProps({
    error: {
      type: Object as () => NuxtError,
      required: true,
    },
  })
</script>

<template>
  <GlobalErrorPage :error="props.error" home-route-name="clientportal-dashboard">
    <template #header>
      <CPGlobalErrorTopBar />
    </template>
  </GlobalErrorPage>
</template>
